import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/manage',
    name: 'Manage',
    component: () => import('../views/manage/Index.vue'),
    children: [
      {
        path: 'list',
        name: 'ManageList',
        component: () => import('../views/manage/DeceasedList.vue')
      },
      {
        path: 'edit/:id?',
        name: 'ManageEdit',
        component: () => import('../views/manage/DeceasedEdit.vue')
      }
    ]
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/admin/Index.vue'),
    children: [
      {
        path: 'qrcode',
        name: 'AdminQrcode',
        component: () => import('../views/admin/QrcodeManage.vue')
      },
      {
        path: 'deceased',
        name: 'AdminDeceased',
        component: () => import('../views/admin/DeceasedManage.vue')
      },
      {
        path: 'user',
        name: 'AdminUser',
        component: () => import('../views/admin/UserManage.vue')
      }
    ]
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () => import('../views/Preview.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
